<template>
  <div :class="{ 'p-6': $mq != 'mobile', 'p-4': $mq == 'mobile' }">
    <p
      class="uppercase text-lg font-medium text-brand text-center my-6"
      v-if="$mq == 'mobile'"
    >
      {{ form.billing.type == "direct-debit" ? "Direct Debit Request - " : "" }}
      Check and Confirm your details
    </p>
    <div :class="{ 'p-6 border': $mq != 'mobile' }">
      <p
        class="uppercase text-lg font-light text-center my-6"
        v-if="$mq != 'mobile'"
      >
        {{
          form.billing.type == "direct-debit" ? "Direct Debit Request - " : ""
        }}
        Check and confirm your details
      </p>

      <div class="flex flex-col sm:flex-row">
        <div
          class="
            w-full
            sm:w-2/3
            py-4
            sm:px-8 sm:border-r
            border-t
            sm:border-t-0
          "
        >
          <!-- header -->
          <div class="flex flex-row justify-between">
            <span class="text-2xl font-light">Property Details</span>
            <button
              class="
                border
                rounded-lg
                bg-brand
                uppercase
                text-grey
                sm:py-2
                py-1
                px-4
                text-white
              "
              @click="goTo(1, 2)"
            >
              Edit
            </button>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">Vault Name</label>
            <p class="font-light mt-2">{{ form.vault.name }}</p>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">Property Type</label>
            <p class="font-light mt-2">{{ form.vault.building_type }}</p>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">Property Address</label>
            <p class="font-light mt-2">{{ form.vault.address }}</p>
            <p class="font-light mt-2">{{ form.vault.suburb }}</p>
            <p class="font-light mt-2">{{ form.vault.state.name }}</p>
            <p class="font-light mt-2">{{ form.vault.postcode }}</p>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">Plan Number</label>
            <p class="font-light mt-2">{{ form.vault.strata_plan_number }}</p>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">Number of Lots</label>
            <p class="font-light mt-2">{{ form.vault.number_of_lots }}</p>
          </div>
        </div>

        <div
          class="
            w-full
            sm:w-2/3
            py-4
            sm:px-8
            border-t
            sm:border-t-0
            border-b
            sm:border-b-0
          "
        >
          <!-- header -->
          <div class="flex flex-row justify-between">
            <span class="text-2xl font-light">Subscription &amp; Billing</span>
            <button
              class="
                border
                rounded-lg
                bg-brand
                uppercase
                text-grey
                sm:py-2
                py-1
                px-4
                text-white
              "
              @click="goTo(3)"
            >
              Edit
            </button>
          </div>

          <div class="flex flex-wrap">
            <div class="w-full sm:w-1/3">
              <div class="my-4 mt-8">
                <label class="text-brand font-medium">Subscription</label>
                <p class="font-light mt-2 capitalize">
                  {{ subscriptions[form.plan][form.plan_cycle].name }}
                </p>
              </div>
            </div>
            <div class="w-full sm:w-1/3">
              <div class="my-4 sm:mt-8">
                <label class="text-brand font-medium">Cost</label>
                <p class="font-light mt-2">
                  $
                  {{
                    convertNumeral(
                      subscriptions[form.plan][form.plan_cycle].price
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="w-full sm:w-1/3">
              <div class="my-4 mt-8">
                <label class="text-brand font-medium">Vault Storage</label>
                <p class="font-light mt-2 capitalize">
                  {{
                    convert(
                      subscriptions[form.plan][form.plan_cycle]
                        .storage_megabytes
                    )
                  }}
                  GB
                </p>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap">
            <div class="w-full sm:w-1/3">
              <div class="my-4 mt-8">
                <label class="text-brand font-medium">Payment Method</label>
                <p class="font-light mt-2">
                  {{ paymentTypes[form.billing.type].name }}
                </p>
              </div>
            </div>
            <div class="w-full sm:w-2/3">
              <div class="my-4 sm:mt-8">
                <label class="text-brand font-medium">Next Billing Date</label>
                <p class="font-light mt-2">
                  {{ compute_next_billing }}, billed
                  <span class="capitalize">{{ form.plan_cycle }}</span>
                </p>
              </div>
            </div>
          </div>

          <div v-if="form.billing.type == 'credit-card'">
            <div class="my-4 mt-8">
              <label class="text-brand font-medium">Credit Card Number</label>
              <p class="font-light mt-2">
                {{ formatCCNumber(form.billing.account_number) }}
              </p>
            </div>

            <div class="my-4 mt-8">
              <label class="text-brand font-medium">Card Expiry</label>
              <p class="font-light mt-2">{{ form.billing.card_expiry }}</p>
            </div>

            <div class="my-4 mt-8">
              <label class="text-brand font-medium">Invoice Email</label>
              <p class="font-light mt-2">{{ form.billing.email }}</p>
            </div>
          </div>

          <div v-if="form.billing.type == 'direct-debit'">
            <div class="my-4 mt-8">
              <label class="text-brand font-medium"
                >Financial Institution</label
              >
              <p class="font-light mt-2">
                {{ form.billing.financial_institution }}
              </p>
            </div>

            <div class="flex flex-wrap">
              <div class="w-1/4">
                <div class="my-4 mt-8">
                  <label class="text-brand font-medium">BSB</label>
                  <p class="font-light mt-2">{{ form.billing.bsb }}</p>
                </div>
              </div>
              <div class="w-3/4">
                <div class="my-4 mt-8">
                  <label class="text-brand font-medium">Account Number</label>
                  <p class="font-light mt-2">
                    {{ form.billing.account_number }}
                  </p>
                </div>
              </div>
            </div>

            <div class="my-4 mt-8">
              <label class="text-brand font-medium">Invoice Email</label>
              <p class="font-light mt-2">{{ form.billing.email }}</p>
            </div>
          </div>

          <div class="my-4 mt-8">
            <label class="text-brand font-medium">End Date</label>
            <p class="font-light mt-2">Ongoing</p>
          </div>

          <div class="text-sm border-t mt-4 pt-4">
            I / We authorise Payrix Australia Pty Ltd ABN 63 135 196 397, User
            ID 382220, to debit payments from my/our account as specified above,
            at intervals and amount as directed by StrataVault (“The Business”)
            as per the Term and Conditions of my agreement with StrataVault in
            accordance with this Direct Debit Request and the Payrix DDR Service
            Agreement provided
            <a href="/DDR-Service-Agreement.pdf" target="_blank">here</a>.
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-end mt-4">
      <div class="flex flex-col">
        <label for="confirm" class="font-light">
          <button
            class="p-1 rounded border border-2"
            type="button"
            id="confirm"
            @click.prevent="confirm_details = !confirm_details"
            :class="{
              'bg-grey-dark': confirm_details,
              'bg-white': !confirm_details,
            }"
          >
            <i class="fa fa-check text-white"></i>
          </button>
          <span class="ml-2">
            Please confirm if all the details are correct
          </span>
        </label>

        <label for="confirm_tc" class="font-light mt-2">
          <button
            class="p-1 rounded border border-2"
            type="button"
            id="confirm_tc"
            @click.prevent="confirm_tc = !confirm_tc"
            :class="{
              'bg-grey-dark': confirm_tc,
              'bg-white': !confirm_tc,
            }"
          >
            <i class="fa fa-check text-white"></i>
          </button>
          <span class="ml-2">
            I have read and agree to the
            <a href="/DDR-Service-Agreement.pdf" target="_blank"
              >Direct Debit Terms &amp; Conditions.</a
            >
          </span>
        </label>
      </div>
    </div>
    <div class="flex flex-row justify-between mt-4">
      <button
        class="
          border
          bg-grey-lighter
          p-4
          w-32
          text-black
          border-grey
          rounded
          font-medium
        "
        type="button"
        @click="back()"
      >
        Back
      </button>
      <button
        class="border bg-brand p-4 text-white rounded font-medium"
        type="submit"
        @click="$refs.t_and_c.open()"
        :class="{
          'cursor-not-allowed opacity-75': !confirm_details || !confirm_tc,
        }"
        :disabled="!confirm_details || !confirm_tc"
      >
        Create your Vault
      </button>
    </div>

    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      enable-mobile-fullscreen
      ref="t_and_c"
      :width="$mq == 'mobile' ? '100%' : '50%'"
    >
      <div class="clearfix">
        <p class="text-brand text-4xl">Terms and Conditions</p>
        <p class="font-semibold text-black">
          To use StrataVault, you must read and agree to the terms and
          conditions.
        </p>
        <div
          class="
            border border-grey
            overflow-y-scroll
            text-left
            p-3
            content
            my-2
          "
        >
          <terms-and-conditions></terms-and-conditions>
        </div>
        <div class="flex justify-between">
          <button
            class="px-4 py-3 font-medium bg-grey text-white rounded"
            @click.prevent="$refs.t_and_c.close()"
          >
            <i class="fa fa-check"></i> I don't agree
          </button>
          <button
            class="
              px-4
              py-3
              font-medium
              bg-white
              text-black
              rounded
              border
              hover:bg-grey-lighter
            "
            @click.prevent="download"
          >
            <i class="fa fa-download text-brand"></i> Download T&amp;Cs
          </button>
          <button
            class="px-4 py-3 font-medium bg-brand text-white rounded"
            @click.prevent="
              $refs.t_and_c.close();
              submit();
            "
          >
            <i class="fa fa-check"></i> I agree
          </button>
        </div>
      </div>
      <div class="h-48 lg:h-auto"></div>
    </sweet-modal>
  </div>
</template>

<script>
import numeral from "numeral";
import TermsAndConditions from "../TermsAndConditions";

export default {
  components: {
    TermsAndConditions,
  },

  props: ["subscriptions", "payment-types", "value", "step"],

  data() {
    return {
      form: _.cloneDeep(this.value),
      show_password: false,
      creating_vault: false,
      show_password_text: "show password",

      prev: "",
      confirm_details: false,
      confirm_tc: false,
    };
  },

  mounted() {
    let prev = _.toNumber(this.step) - 1;
    this.prev = prev;
  },

  methods: {
    convertNumeral(number) {
      return numeral(number).format("0,0.00");
    },
    goTo(step, sub_step) {
      this.$emit("go-to", {
        next_step: step,
        next_sub_step: sub_step,
        detail_review: true,
      });
    },
    showPassword() {
      if (this.show_password) {
        this.show_password = false;
      } else {
        this.show_password = true;
      }
    },
    submit() {
      this.creating_vault = true;
      this.$emit("update-form", {
        form: this.form,
        submit: true,
      });
    },
    back() {
      this.$emit("go-to", {
        next_step: this.prev,
      });
    },
    download() {
      axios
        .get("/download-t-and-c", { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Terms and Conditions.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    convert(megabytes) {
      return Math.floor(megabytes / 1024);
    },
    convertNumeral(number) {
      return numeral(number).format("0,0.00");
    },
    formatCCNumber(number) {
      let s = number.replace(/\s/g, "");
      const placeholder = s.length == 15 ? "XXXXX" : "XXXXXX";
      s = `${s.substr(0, 6)}${placeholder}${s.substr(-4, 4)}`;
      if (s.length == 15) {
        return (
          s.substr(0, 4) + " " + s.substr(4, 6) + " " + s.substr(-5, s.length)
        );
      }
      return s.match(/.{1,4}/g).join(" ");
    },
  },

  computed: {
    display_password() {
      if (this.show_password) {
        this.show_password_text = "Hide Password";
        return this.form.user.password;
      } else {
        this.show_password_text = "Show Password";
        return "*****";
      }
    },
    compute_next_billing() {
      if (this.form.plan_cycle == "monthly") {
        return moment().add(1, "months").format("dddd, MMMM Do YYYY");
      }

      if (this.form.plan_cycle == "yearly") {
        return moment().add(1, "years").format("dddd, MMMM Do YYYY");
      }
    },
  },
};
</script>

<style>
.content {
  height: 380px;
}
.clearfix {
  clear: both;
}
</style>
